import { render, staticRenderFns } from "./InvoicePdfButton.vue?vue&type=template&id=21cc4f58&"
import script from "./InvoicePdfButton.vue?vue&type=script&lang=ts&"
export * from "./InvoicePdfButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports